import { PERMISSION_KEYS } from 'constants-permissions';
import { Action } from '../Action';
import {
  hasAnyPermission,
  isAssigneeOrTeamMember,
  isOwner,
  isSuperUser,
} from '../predicates';
import type { ServiceRequestResource } from '../Resource';
import { evaluateRules, type AccessRequest, type Rule } from '../Rule';

const ALL = [Action.Create, Action.Read, Action.Delete] as const;
const READ = [Action.Read] as const;

export const SERVICE_REQUEST_RULES: readonly Rule<ServiceRequestResource>[] = [
  { name: 'superuser', actions: ALL, appliesTo: isSuperUser },
  {
    name: 'admin',
    actions: ALL,
    appliesTo: hasAnyPermission([PERMISSION_KEYS.PERMISSION_ADMIN]),
  },
  { name: 'owner', actions: ALL, appliesTo: isOwner },
  {
    name: 'attach-file',
    actions: ALL,
    appliesTo: hasAnyPermission([
      PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_ATTACH_FILE,
    ]),
  },
  {
    name: 'view-all',
    actions: READ,
    appliesTo: hasAnyPermission([
      PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_VIEW,
    ]),
  },
  { name: 'assignee-team', actions: READ, appliesTo: isAssigneeOrTeamMember },
];

export const canAccessServiceRequestAttachment = (
  request: AccessRequest<ServiceRequestResource>
): boolean => evaluateRules(SERVICE_REQUEST_RULES, request);
